import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
/**
 * Builder for creating a Cell configuration.
 * The configuration contains 2 flags basically
 * 1. Component: Mentions the component to render for the config.
 * 2. shouldRender: A function to determine whether to render the particular cell config.
 */
import _stubFalse from 'lodash/stubFalse';
import _noop from 'lodash/noop';
var CellConfig = /*#__PURE__*/function () {
  function CellConfig() {
    _classCallCheck(this, CellConfig);
    /**
     * We dont know what input to render as default. Hence we are setting the same as null.
     * Cannot put the default as a component as well coz we have a case where in specific cases we dont want to display cell.
     */
    this.component = null;
    /**
     * A function which returns a boolean to indicate whether to render a config or not.
     * This particular configuration is not needed when you have a single cell config in the column config.
     * It defaults to a function which always returns false.
     */
    this.shouldRender = _stubFalse;
    this.mapCellPropsToComponentProps = _noop;
  }

  /**
   * This method is used to basically set the component to render in the cell config.
   */
  _createClass(CellConfig, [{
    key: "setComponent",
    value: function setComponent() {
      var component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.component = component;
      return this;
    }

    /**
     * This method is used to set the shouldRender method in the config.
     * Again this config is only required when you have multiple cell configs in column config.
     */
  }, {
    key: "setShouldRender",
    value: function setShouldRender() {
      var shouldRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _stubFalse;
      this.shouldRender = shouldRender;
      return this;
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.component;
    }
  }, {
    key: "getShouldRender",
    value: function getShouldRender() {
      return this.shouldRender;
    }
  }, {
    key: "getMapCellPropsToComponentProps",
    value: function getMapCellPropsToComponentProps() {
      return this.mapCellPropsToComponentProps;
    }
  }]);
  return CellConfig;
}();
export default CellConfig;